@for (message of messages; track message; let i = $index) {
  @if (message.role !== "system") {
    <div class="my-3">
      <h5 class="my-1">{{ message.role }}</h5>
      <markdown
        class="markdown my-2 line-height-3"
        [data]="message.content"
        #markdown
      />
    </div>
  }
}
